// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type CourseObligationScope = (typeof CourseObligationScope)[keyof typeof CourseObligationScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseObligationScope = {
  module_default: 'module_default',
  course_override: 'course_override',
} as const;
